import { List } from "immutable";

import CourseExamQuestionsSpec from "seneca-common/features/assignments/state/models/spec/CourseExamQuestionsSpec";
import CourseSectionsSpec from "seneca-common/features/assignments/state/models/spec/CourseSectionsSpec";

export function getCourseId(
  spec: CourseSectionsSpec | CourseExamQuestionsSpec
) {
  return spec.courseId;
}

export function getSectionIds(spec: CourseSectionsSpec): List<string> {
  return spec.sectionIds;
}

export function getExamQuestionIds(
  spec: CourseSectionsSpec | CourseExamQuestionsSpec
): List<string> {
  return spec.questionIds;
}
